// extracted by mini-css-extract-plugin
export var dividerContainer = "_6v-0";
export var line = "_6v-1";